import { render, staticRenderFns } from "./activity-list-task.vue?vue&type=template&id=2aed202a&scoped=true"
import script from "./activity-list-task.vue?vue&type=script&lang=js"
export * from "./activity-list-task.vue?vue&type=script&lang=js"
import style0 from "./activity-list-task.vue?vue&type=style&index=0&id=2aed202a&prod&lang=css"
import style1 from "./activity-list-task.vue?vue&type=style&index=1&id=2aed202a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed202a",
  null
  
)

export default component.exports